// src/services/authService.js
import axios from "axios";
import { authHeader } from "./auth-headerService";
import { resolveApiBaseUrl } from "@/utils/hostname";

const API_URL = process.env.VUE_APP_API_URL || "http://127.0.0.1:8000/api/";

class AuthService {
  apiUrl() {
    return resolveApiBaseUrl();
  }
  async login(user) {
    const response = await axios.post(this.apiUrl() + "login", {
      email: user.email,
      password: user.password,
    });

    // if (response.data?.token) {
    //   localStorage.setItem("user", JSON.stringify(response.data));
    // }

    return response;
  }

  logout() {
    localStorage.removeItem("user");
    delete axios.defaults.headers.common["Authorization"];
  }

  async checkAuth() {
    try {
      const res = await axios.get(API_URL + "users", {
        headers: authHeader(),
      });
      return res.status;
    } catch (error) {
      return error.response?.status || 401;
    }
  }

  // 🔹 NEW: public company + admin registration
  async register(user) {
    const payload = {
      company_name: user.company_name,
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      password: user.password,
      password_confirmation: user.password_confirmation,
      country_code: user.country_code || null,
      currency_code: user.currency_code || null,
      timezone: user.timezone || null,
      plan_id: user.plan_id || null,
    };

    if (user.slug) {
      payload.slug = user.slug;
    }

    return axios.post(API_URL + "public/register-company", payload, {
      timeout: 300000,
    });
  }

  getUser() {
    return axios.get(this.apiUrl() + "user", {
      headers: authHeader(),
    });
  }

  resendVerificationEmail() {
    return axios.post(
      this.apiUrl() + "email/verification-notification",
      {},
      {
        headers: authHeader(),
      }
    );
  }

  forgotPassword(resource) {
    return axios.post(this.apiUrl() + "password/forgot", resource);
  }

  resetPasswordPublic(resource) {
    return axios.post(this.apiUrl() + "password/reset", resource);
  }

  confirmPassword(resource) {
    return axios.post(this.apiUrl() + "security/confirm-password", resource, {
      headers: authHeader(),
    });
  }

  async forgotPasswordOtp(resource) {
    return axios.post(API_URL + "generate-otp", resource, {
      headers: authHeader(),
    });
  }

  async verifyOtp(resource) {
    return axios.post(API_URL + "verify-otp", resource, {
      headers: authHeader(),
    });
  }

  async verifyUser(resource) {
    return axios.post(API_URL + "verify-user", resource, {
      headers: authHeader(),
    });
  }

  async resetPassword(resource) {
    return axios.post(API_URL + "reset-password", resource, {
      headers: authHeader(),
    });
  }

  async resendRegistrationOtp(resource) {
    return axios.post(API_URL + "resend-registration-otp", resource, {
      headers: authHeader(),
    });
  }


async impersonateCompany(companyId) {
  return axios.post(API_URL + `superadmin/companies/${companyId}/impersonate`, null, {
    headers: authHeader(),
  });
}

}

export default new AuthService();
